import { FETCH_CLASS } from '../../actions/class/classDetail'
import Class from '../../models/Class'
import { ApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'

export interface FetchClassState extends ApiState {
    class?: Class
}

export default requestReducer<FetchClassState>(FETCH_CLASS)